import { CladdingCellStyle } from "./panelSource";

export type WindowOverlapsSetting = {
    left: number;
    top: number;
    right: number;
    bottom: number;
};

export type SystemSettings = {
    windowOverlaps: WindowOverlapsSetting;
    acmWindowOverlaps: WindowOverlapsSetting;
    louvreOverlaps: WindowOverlapsSetting;
    acmLouvreOverlaps: WindowOverlapsSetting;
    windowFrameOffset: WindowOverlapsSetting;
    louvreFrameOffset: WindowOverlapsSetting;
    windowSillHeight: number;
};

export const getWindowOverlapsSetting = (
    systemSettings: SystemSettings,
    style: CladdingCellStyle,
): WindowOverlapsSetting => {
    return style === CladdingCellStyle.Acm ? systemSettings.acmWindowOverlaps : systemSettings.windowOverlaps;
};

export const getLouvreOverlapsSetting = (
    systemSettings: SystemSettings,
    style: CladdingCellStyle,
): WindowOverlapsSetting => {
    return style === CladdingCellStyle.Acm ? systemSettings.acmLouvreOverlaps : systemSettings.louvreOverlaps;
};
